<template>
  <div class="grid-item grid-item-header product_list-item">
    <slot name="slot-column"></slot>
    <div class="fav">
    </div>
    <div class="articul">
      <span>{{ $t('product_code') }}</span>
    </div>
    <div class="brand">
      <span>{{ $t('brand') }}</span>
    </div>
    <div class="name">
      <span>{{ $t('product_name') }}</span>
    </div>
    <div class="store-name">
      <span v-if="!$noCartMode() && !$hideStockAvailabilityColumns() || forceShowAvailColumn">{{ $t('stock_pcs') }}</span>
    </div>
    <div class="availability">
      <span v-if="!$hideStockAvailabilityColumns() || forceShowAvailColumn">{{ $t('available') }}</span>
    </div>
    <div class="price" v-if="!$noCartMode()">
      <span>{{ $t('price_rub') }}</span>
      <span class="upper">{{$t('no_vat')}}</span>
    </div>
    <div class="price" v-if="$noCartMode()">
      <span>{{ $t('price') }}</span>
      <span class="upper">{{$t('no_vat')}}</span>
    </div>
    <div class="order order-qnt-edit" v-if="!$noCartMode()">
      <span>{{ $t('order') }}</span>
    </div>
    <div class="cart-col" v-if="!$noCartMode()" />
  </div>
</template>

<script>
export default {
  props: {
    forceShowAvailColumn: { type: Boolean, default: false },
  },
}
</script>

<i18n lang="yaml">
ru:
  stock_pcs: 'Склад'
  order: 'Добавить'
  available: 'Наличие'
en:
  stock_pcs: 'Stock'
  order: 'Add'
  available: 'Availability'
</i18n>
